/**
 * Set focus to the view with the given name.
 * @param name The name of the view to set focus to
 */
export const setFocus = (name: string): void => {
  const el = document.getElementById(`view-${name}`);
  el?.focus({ preventScroll: true });
};

export default setFocus;
